import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { GetCodiciUtente as GetCodiciUtenteReducer } from '../../reducers/r_index';
import { EditLicense as EditLicenseReducer } from '../../reducers/r_index';
import { SendLicenseDetails as SendLicenseDetailsReducer } from '../../reducers/r_index';
import { MultiViewGestioneLicenze as MultiViewReducer } from '../../reducers/r_index';
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { FilterLicenses as FilterLicensesReducer } from '../../reducers/r_index';

//Components
import ModificaLicenzaCmp from '../../components/gestione_licenze/ModificaLicenzaCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class ModificaLicenza extends Component {

    componentDidMount() {
        const { selected_license } = this.props;

        // se admin inizializzo dati tenendo conto del CodiceUtente della licenza selezionata e inizializzo tutti i codici_utente
        if (this.props.codiceUtente === 'CODICEADMIN') {
            this.props.initializeFields(selected_license.DataScadenza, selected_license.Cliente, selected_license.Email, selected_license.CodiceUtente);
            this.props.getCodiciUtente();
        }// altrimenti inizializzo i dati tenendo conto del CodiceUtente dell'utente loggato
        else this.props.initializeFields(selected_license.DataScadenza, selected_license.Cliente, selected_license.Email, this.props.codiceUtente);

    }

    render() {
        const { ...props } = this.props;

        return (
            <ModificaLicenzaCmp {...props} />
        );

    }
}

ModificaLicenza.propTypes = {
    //editLicense
    editLicense: PropTypes.func.isRequired,
    editLicenseRequestStatus: PropTypes.string.isRequired,
    editLicenseErrorMessage: PropTypes.string,
    isModified: PropTypes.string.isRequired,

    //sendLicenseDetails
    sendLicenseDetails: PropTypes.func.isRequired,
    sendLicenseDetailsStatus: PropTypes.string.isRequired,
    sendLicenseDetailsErrorMessage: PropTypes.string,
    isSent: PropTypes.string.isRequired,

    new_license_data: PropTypes.shape({
        hasScadenza: PropTypes.bool,
        data_scadenza: PropTypes.any,
        cliente: PropTypes.string,
        email: PropTypes.string,
        codice_utente: PropTypes.string,
    }).isRequired,

    handleChangeFieldNewData: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,

    resetEditLicenseData: PropTypes.func.isRequired,

    isChanged: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,

    errorText: PropTypes.shape({}).isRequired,

    changeViewSelection: PropTypes.func.isRequired,


    selected_license: PropTypes.shape({
        ProductKey: PropTypes.any,
        ID: PropTypes.any,
        SerialNumberOld: PropTypes.any,
        IDModulo: PropTypes.any,
        Tipologia: PropTypes.any,
        DataDecorr: PropTypes.any,
        DataScadenza: PropTypes.any,
    }).isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};


const mapDispatchToProps = dispatch => ({
    editLicense: (pk, new_license_data) => { dispatch(EditLicenseReducer.creators.editLicenseRequest(pk, new_license_data)) },

    sendLicenseDetails: (pk, email) => { dispatch(SendLicenseDetailsReducer.creators.sendLicenseDetailsRequest(pk, email)); },

    handleChangeFieldNewData: (field, newValue) => { dispatch(EditLicenseReducer.creators.handleChangeFieldNewData(field, newValue)) },

    resetEditLicenseData: () => { dispatch(EditLicenseReducer.creators.resetEditLicenseData()) },
    initializeFields: (data_scadenza, cliente, email, codice_utente) => { dispatch(EditLicenseReducer.creators.initializeFields(data_scadenza, cliente, email, codice_utente)) },
    validateField: (field) => { dispatch(EditLicenseReducer.creators.validateField(field)) },


    getCodiciUtente: () => { dispatch(GetCodiciUtenteReducer.creators.getCodiciUtenteRequest()); },
    changeViewSelection: newView => dispatch(MultiViewReducer.creators.changeViewSelection(newView)),


    refreshLicenses: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },
    resetFilters: () => { dispatch(FilterLicensesReducer.creators.resetFilters()) },

});

const mapStateToProps = state => ({
    //editLicense
    editLicenseRequestStatus: state['edit-license'].status,
    editLicenseErrorMessage: state['edit-license'].error,
    isModified: state['edit-license'].isModified,

    //sendLicenseDetails
    sendLicenseDetailsStatus: state['send-license-details'].status,
    sendLicenseDetailsErrorMessage: state['send-license-details'].error,
    isSent: state['send-license-details'].isSent,

    new_license_data: state['edit-license'].new_license_data,

    isChanged: state['edit-license'].isChanged,
    isValid: state['edit-license'].isValid,

    errorText: state['edit-license'].errorText,

    selected_license: state['filtro-licenze'].selected_license,

    codiceUtente: state['logged-user'].codiceUtente,

    getCodiciUtenteRequestStatus: state['codici-utente'].status,
    codici_utente: state['codici-utente'].codici_utente,

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ModificaLicenza));